<p-confirmDialog [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<div class="row">
	<div class="col-lg-12">
		<div class="ibox float-e-margins">
			<div class="ibox-content">
				<form name="ActionForm" class="form-horizontal" role="form" novalidate>
					<!-- <div class="form-group">
                        <label class="col-sm-3 col-lg-2 control-label">District</label>
                        <div class="col-sm-4 col-lg-3">
                            <select  class="form-control" name="SchoolID" (ngModelChange)="onSchoolChange($event)" [(ngModel)]="report.SchoolID">
                               
                                <option *ngFor="let o of schoolList" [ngValue]="o.SchoolID">{{o.SchoolName}}</option>
                            </select>
                        </div>
                    </div> -->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">District Name</label>
						<div class="col-sm-4 col-lg-3">
							<input type="text" class="form-control" name="DistrictName" [(ngModel)]="Contact.DistrictName" />
						</div>
					</div>

					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Login Page Display Name</label>
						<div class="col-sm-4 col-lg-3">
							<input type="text" class="form-control" name="DistrictDisplayName" [(ngModel)]="Contact.DistrictDisplayName" />
						</div>
					</div>

					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Phone</label>
						<div class="col-sm-4 col-lg-3">
							<!-- <p class="form-control" >  {{Contact?.Phone}} </p>  -->
							<input type="text" class="form-control" name="Phone" [(ngModel)]="Contact.Phone" />
						</div>
					</div>
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Street</label>
						<div class="col-sm-4 col-lg-3">
							<!-- <p class="form-control">{{Contact?.Street}} </p> -->
							<input type="text" class="form-control" name="Street" [(ngModel)]="Contact.Street" />
						</div>
					</div>
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">City</label>
						<div class="col-sm-4 col-lg-3">
							<input type="text" class="form-control" name="City" [(ngModel)]="Contact.City" />

							<!-- <p class="form-control">{{Contact?.City}} </p> -->
						</div>
					</div>
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">State</label>
						<div class="col-sm-4 col-lg-3">
							<input type="text" class="form-control" name="State" [(ngModel)]="Contact.State" />
							<!-- <p class="form-control">{{Contact?.State}} </p> -->
						</div>
					</div>
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Zip</label>
						<div class="col-sm-4 col-lg-3">
							<input type="text" class="form-control" name="Zip" [(ngModel)]="Contact.Zip" />
							<!-- <p class="form-control">{{Contact?.Zip}} </p> -->
						</div>
					</div>
					<div class="hr-line-dashed"></div>
					<!-- <div class="form-group">
                        <div name="errorMessage" *ngIf="errorMessage"  class='alert alert-danger'>{{SaveErrorMessage}}</div>
                        
                    </div> -->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label"></label>

						<div class="col-md-4 col-lg-3">
							<!-- <div name="Saveing" *ngIf="isProcessing" class='alert alert-info'>Processing.Please wait...</div> -->
							<button class="btn btn-primary" type="button" (click)="UpdateDistrict()">Update</button>&nbsp;
						</div>
					</div>

					<div class="row">
						<div class="col-lg-6">
							<div id="SaveErrorMessage" *ngIf="SaveErrorMessage" class="alert alert-danger">
								{{ SaveErrorMessage }}
							</div>

							<div id="SaveDone" *ngIf="SaveDone" class="alert alert-success">Key successfully sent</div>
						</div>
					</div>
				</form>
			</div>
		</div>
	</div>
</div>
